export const TableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'firstName', label: 'First Name' },
  { key: 'lastName', label: 'Last Name' },
  { key: 'isArchived', label: 'Status' },
  { key: 'baseCityName', label: 'Base City' },
  { key: 'phone', label: 'Phone' },
  { key: 'cityName', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'zip', label: 'Zip' },
];
